/**
 * Build styles
 */
require('./index.css').toString();
const { make } = require('./util');

export default class OverlayTool {
  /**
   * Default colour
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_COLOR() {
    return '';
  }

  static get isTune() {
    return true;
  }

  getColor() {
    if (this.settings?.blocks?.hasOwnProperty(this.block.name)) {
      return this.settings.blocks[this.block.name];
    }
    if (this.settings?.default) {
      return this.settings.default;
    }
    return OverlayTool.DEFAULT_COLOR;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;

    this.colors = ["transparent","#000000", ...config.options];

    this.data = {
      color: data?.color || this.getColor(),
      opacity: data?.opacity !== undefined ? data.opacity : 1
    };

    this._CSS = {
      wrapper: 'cdx-color-picker-settings',
      button: 'cdx-color-picker-button',
      span: 'cdx-color-picker',
      slider: 'cdx-opacity-slider',
      sliderLabel: 'cdx-opacity-slider-label',
      overlay: 'overlay-color',
      tuneWrapper: 'editor-block-tune',
      tuneTitle: 'editor-block-tune-title',
      tuneText: 'editor-block-tune-text',
      tuneInput: 'editor-block-tune-input',
      tuneContent: 'editor-block-tune-content-container'
    };

    this.wrapper = null; // Will be assigned in wrap()
  }

  wrap(blockContent) {
    this.wrapper = make("div");
    this.wrapper.style.width = "100%";
    this.wrapper.style.height = "100%";
    this.wrapper.append(blockContent);

    const target = this.wrapper.querySelector(".cdx-media-container");
    const imgTarget = this.wrapper.querySelector(".cdx-media-wrapper");

    if (target) {
      target.style.backgroundColor = this.data.color;
    }

    if (imgTarget) {
      imgTarget.style.opacity = this.data.opacity;
    }

    return this.wrapper;
  }

  render() {
    const wrapper = make("div", [this._CSS.wrapper, this._CSS.overlay, this._CSS.tuneWrapper]);
    const colorLabel = make("label", [this._CSS.tuneTitle]);
    const content = make("div", [this._CSS.tuneContent]);
    const slider = make("input", [this._CSS.slider, this._CSS.tuneInput]);
    const sliderLabel = make("label", [this._CSS.sliderLabel, this._CSS.tuneTitle]);

    colorLabel.innerText = 'Image background colour';
    slider.type = 'range';
    slider.min = '0';
    slider.max = '1';
    slider.step = '0.01';
    slider.value = this.data.opacity;
    slider.id = 'overlayOpacitySlider';
    slider.name = 'overlayOpacitySlider';
    sliderLabel.innerText = `Image Opacity: ${Math.floor(this.data.opacity * 100)}%`;

    // Color buttons
    const colorButtons = this.colors.map(color => {
      const button = document.createElement('button');
      const span = document.createElement('span');

      if(color === "transparent"){
        button.classList.add('transparent');
      }
      button.classList.add(this._CSS.button);
      button.type = 'button';
      span.classList.add(this._CSS.span);
      span.style.boxShadow = `${color} 0px 0px 0px 15px inset`;

      button.classList.toggle('colorCircleActive', color === this.data.color);
      button.appendChild(span);
      content.appendChild(button);

      return button;
    });

    colorButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.data = {
          ...this.data,
          color: this.colors[index]
        };

        colorButtons.forEach((btn, i) => {
          btn.classList.toggle('colorCircleActive', this.colors[i] === this.data.color);
        });

        const target = this.wrapper?.querySelector(".cdx-media-container");
        if (target) {
          target.style.backgroundColor = this.data.color;
        }

        this.save();
      });
    });

    slider.addEventListener('input', (e) => {
      const value = parseFloat(e.target.value);
      this.data.opacity = value;
      sliderLabel.innerText = `Image Opacity: ${Math.floor(value * 100)}%`;

      const imgTarget = this.wrapper?.querySelector(".cdx-media-wrapper");
      if (imgTarget) {
        imgTarget.style.opacity = value;
      }

      this.save();
    });

    wrapper.appendChild(colorLabel);
    wrapper.appendChild(content);
    wrapper.appendChild(sliderLabel);
    wrapper.appendChild(slider);

    return wrapper;
  }

  save() {
    return this.data;
  }

  destroy() {
    this.block = null;
    this.wrapper = null;
  }
}
